<template>
  <div class="main-window-l">
    <div class="step-nav">
      <div class="nav-item active">
        个人资料
      </div>
    </div>

    <div class="center-pc">
      <div v-if="!isNewReg" class="list">
        <div class="centerItem">
          <label class="name">用户名</label>
          <label class="look">{{
        detailForm.bindEmail || detailForm.bindMobile
      }}</label>
        </div>
        <div class="centerItem">
          <label class="name">姓名</label>
          <label class="look">{{ detailForm.currentGuestName }}</label>
        </div>
        <div class="centerItem">
          <label class="name">性别</label>
          <label class="look">{{
        detailForm.currentSex == 1 ? "男" : "女"
      }}</label>
        </div>
        <!-- <div class="centerItem">
          <label class="name">证件类型</label>
          <label class="look">{{ detailForm.certType }}</label>
        </div> -->
        <div class="centerItem">
          <label class="name">证件号码</label>
          <label class="look">{{ detailForm.currentCertNo }}</label>
        </div>
      </div>
      <div v-else class="list">
        <div class="centerItem">
          <label class="name">姓名</label>
          <input placeholder="请输入姓名" class="txtin" v-model="detailForm.guestName" autocomplete="off" />
        </div>
        <div class="centerItem">
          <label class="name">艺名</label>
          <input placeholder="请输入艺名" class="txtin" v-model="detailForm.artName" autocomplete="off" />
        </div>
        <div class="centerItem">
          <label class="name">证件类型</label>
          <select class="types" name="cert_type" v-model="detailForm.certType">
            <option v-for="(item, index) in $certTypeOp" :key="index" :value="item.id">{{ item.title }}</option>
          </select>
        </div>
        <div class="centerItem">
          <label class="name">证件号码</label>
          <input placeholder="请输入证件号码" class="txtin" v-model="detailForm.certNo" autocomplete="off" />
        </div>
        <div class="centerItem">
          <label class="name">手机号</label>
          <label class="look">{{ detailForm.mobile }}</label>
        </div>
      </div>
    </div>
    <div :class="['foo', { 'center': !isNewReg }]">
      <div>
        <button class="leftBtn" @click="goBack">返回</button>
        <button v-if="isNewReg" class="rightBtn" @click="submit">修改</button>
      </div>
    </div>
  </div>
</template>

<script>
import { sessionData } from "@/static/js/local.js";
import { updateGuestMainInfo } from "@/api/newUser";

export default {
  name: "userInfo",
  components: {},
  data() {
    return {
      detailForm: {},
      isNewReg: false
    };
  },
  created() {
    if (!this.$cookies.isKey("token")) {
      this.$router.push("/login");
    } else {
      if (this.$cookies.get("regType") == 2) {
        this.isNewReg = true;
      } else {
        this.isNewReg = false;
      }
    }
  },
  mounted() {
    this.detailForm = sessionData("get", "UserInfo");
  },
  methods: {
    goBack() {
      this.$router.push('/userIndex');
    },
    submit() {
      this.$msgbox({
        title: "确认信息",
        message: "确认修改个人信息？",
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "cancel-btn-color",
        confirmButtonClass: "btn-color",
        callback: (action, instance) => {
          if (action == "confirm") {
            updateGuestMainInfo({
              guestName: this.detailForm.guestName,
              artName: this.detailForm.artName,
              certType: this.detailForm.certType,
              certNo: this.detailForm.certNo
            }).then(res => {
              if (res.code == 200) {
                this.$message.success('操作成功');
                setTimeout(() => {
                  this.goBack();
                }, 500);
              }
            })
          }
        }
      });
    }
  }
};
</script>

<style src="../../static/css/regist.css" scoped></style>
<style src="../../static/css/infoCommon.css" scoped></style>
